import React, { useEffect, useState } from 'react';
import Select from 'react-select/async';
import './asyncSelect.scss';
import { api } from '../../../helpers/api_helper';

const mapLocationResponseToOptions = (data) => {
    return data.location_data.map(location => ({
        label: location.display_name,
        value: location.display_name,
        lat: location.lat,
        lon: location.lon
    }));
};

const AsyncSelectComponent = ({ apiUrl, placeholder, selectedLocation, value, disableStatus, errorHandle }) => {
    const [selectedOption, setSelectedOption] = useState(value ? { label: value, value: value } : null);
    const [error, setError] = useState(false);

    let timeoutId;

    const loadOptions = (inputValue, callback) => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        if (!inputValue) {
            return callback([]);
        }

        if (inputValue.length >= 3) {
            timeoutId = setTimeout(() => {
                api.create(apiUrl, { location: inputValue })
                    .then(response => {
                        const options = mapLocationResponseToOptions(response.data);
                        callback(options);
                        setError(false)

                    })
                    .catch(error => {
                        setError(true)
                        callback([]);
                    });
            }, 500); // Adjust the delay time as needed (500ms in this example)
        } else {
            callback([]);
        }
    };


    const handleChange = selectedOption => {
        console.log('changed location', selectedOption);
        selectedLocation(selectedOption);
        setSelectedOption(selectedOption);
    };

    useEffect(() => {
        errorHandle(error)
    }, [error]);

    return (
        <div>
            <Select
                disabled={true} // Corrected to a boolean
                className={`input_field custom_select_box ${disableStatus ? 'disabled' : ''}`}
                cacheOptions
                loadOptions={loadOptions}
                onChange={handleChange}
                defaultOptions
                value={selectedOption}
                placeholder={placeholder}
                noOptionsMessage={() => null}
                isClearable
                onFocus={console.log('focused')}
            />
        </div>
    );
};

export default AsyncSelectComponent;
